import React from "react";
import Layout from "../../components/layout";
import HeaderOne from "../../components/header/header-one";
import StickyHeader from "../../components/header/sticky-header";
import Footer from "../../components/footer";
import ComingSoon from "../Work/Coming-soon";
const Rotary = () => {
  return (
    <Layout pageTitle="Rotary-clubs">
      <HeaderOne />
      <StickyHeader />
      <section className="bg-comingSoon">
        <ComingSoon />
      </section>
      <Footer />
    </Layout>
  );
};
export default Rotary